/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../theme';
const LeftGutter = (props) => {
    const { selected, ...divProps } = props;
    const theme = useTheme();
    return (jsx("div", Object.assign({ contentEditable: false }, divProps, { css: {
            position: 'relative',
            width: '12px',
            minWidth: '12px',
            background: selected
                ? theme.colors.leftGutter.backgroundSelected
                : theme.colors.leftGutter.background,
            '&:hover:before': {
                display: 'block',
                content: '" "',
                background: theme.colors.leftGutter.background,
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                width: '42px',
                height: 'auto',
                marginBottom: '2px',
            },
            '& *': {
                visibility: 'hidden',
            },
            '&:hover *': {
                visibility: 'visible',
            },
        } })));
};
export default React.memo(LeftGutter);
//# sourceMappingURL=LeftGutter.js.map